(function () {
  'use strict';

  if (window.nearkiiProductAccordionLoaded) {
    return;
  }

  window.nearkiiProductAccordionLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 640px)');

  function getDirectChild(accordion, className) {
    var children = accordion.children;

    for (var i = 0; i < children.length; i += 1) {
      if (children[i].classList.contains(className)) {
        return children[i];
      }
    }

    return null;
  }

  function syncAccordions(root) {
    var scope = root || document;
    var accordions = scope.querySelectorAll('[data-nearkii-mobile-accordion]');

    accordions.forEach(function (accordion) {
      var toggle = getDirectChild(accordion, 'nearkii-mobile-accordion__toggle');
      var panel = getDirectChild(accordion, 'nearkii-mobile-accordion__panel');

      if (!toggle || !panel) {
        return;
      }

      if (!accordion.hasAttribute('data-nearkii-accordion-initialized')) {
        accordion.setAttribute('data-nearkii-accordion-initialized', 'true');
        accordion.setAttribute('data-nearkii-mobile-expanded', 'false');
      }

      if (mobileQuery.matches) {
        var expanded = accordion.getAttribute('data-nearkii-mobile-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        panel.hidden = !expanded;
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.nearkii-mobile-accordion__toggle');

    if (!toggle || !mobileQuery.matches) {
      return;
    }

    var accordion = toggle.closest('[data-nearkii-mobile-accordion]');
    var panel = accordion && getDirectChild(accordion, 'nearkii-mobile-accordion__panel');

    if (!accordion || !panel) {
      return;
    }

    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    accordion.setAttribute('data-nearkii-mobile-expanded', expanded ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.hidden = expanded;
  });

  document.addEventListener('shopify:section:load', function (event) {
    syncAccordions(event.target);
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      syncAccordions(document);
    });
  } else {
    mobileQuery.addListener(function () {
      syncAccordions(document);
    });
  }

  syncAccordions(document);
})();
